export default __webpack_public_path__ + "static/media/man.68e80fb3.png";